import React from 'react';

import { EventType } from 'types/event.types';
import LoadingSpinner from 'components/common/loaders/LoadingSpinner/LoadingSpinner';
import { useEditableEvent } from 'pages/dashboard/overview/events/editor/hooks/useEditableEvent';
import { Separator } from '@epoch-ui/components/Separator';
import { useSessionsQuery } from '@event-editor/hooks/useSessionsQuery';

import { RegistrationSettingsSection } from './sections/RegistrationSettingsSection';
import { SessionsSection } from './sections/SessionsSection';
import { GuestsSection } from './sections/GuestsSection';
import { QuestionnaireQuestionsSection } from './sections/QuestionnaireQuestionsSection';
import { RegistrationsByPlatform } from './sections/RegistrationsByPlatform';
import { QuestionnaireResponsesSection } from './sections/QuestionnaireResponsesSection';

export const EditEventRegistration = (): React.ReactElement | null => {
  const event = useEditableEvent();

  const { data: eventSessions, isLoading: isLoadingEventSessions } = useSessionsQuery(event, {
    sortParams: { sortBy: 'start_datetime', sortOrder: 'ASC' },
    enabled: !!event.id && event.isPublished && event.eventType === EventType.MULTI_SESSIONS,
    select: (data) => data.filter((session) => session.isPublished)
  });

  if (isLoadingEventSessions) {
    // Maybe add skeletons here?
    return <LoadingSpinner />;
  }

  return (
    <div className="tw-space-y-10">
      <RegistrationSettingsSection />

      {event.eventType === EventType.MULTI_SESSIONS && event.isPublished && (
        <SessionsSection sessions={eventSessions ?? []} />
      )}

      <GuestsSection />

      <Separator />
      {event.isPublished && (
        <>
          <RegistrationsByPlatform />
          <Separator />
        </>
      )}

      {event.preeventEnable && (
        <>
          <QuestionnaireResponsesSection />
          <Separator />
        </>
      )}
      <QuestionnaireQuestionsSection />
    </div>
  );
};
